module.exports = "<div class=\"device-info\">\r\n    <span class=\"bold\">Schalter {{ deviceModel.name }}</span><br/>\r\n    <ui-switch *ngIf=\"deviceModel.checked\" [(checked)]=\"enable\" (click)=\"switchDevice(deviceModel)\"></ui-switch>\r\n    <ui-switch *ngIf=\"!deviceModel.checked\" (click)=\"switchDevice(deviceModel)\"></ui-switch>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/device-info/device-info.component.html
// module id = ./src/app/components/device-info/device-info.component.html
// module chunks = main